import type { NormalizedDocument } from '@core/doc/types';
import type { BusinessIdentity } from '@core/doc/renderA4';
import { renderQuotationPackage } from '@core/doc/quotationRender';
import { createPrintPort } from '@platform/print/createPrintPort';
import type { PrintableDocument } from '@platform/print/printPort';

export function printableQuotation(m: NormalizedDocument, biz: BusinessIdentity, assetsBaseUrl = ''): PrintableDocument {
  return {
    html: renderQuotationPackage(m, biz, assetsBaseUrl),
    fileName: `${biz.legalName}-${m.docNumber}`.replace(/[^\w.-]+/g, '-'),
    target: 'a4',
  };
}

export async function printQuotation(m: NormalizedDocument, biz: BusinessIdentity, assetsBaseUrl = '') {
  return createPrintPort().print({ document: printableQuotation(m, biz, assetsBaseUrl) });
}

export async function saveQuotationPdf(m: NormalizedDocument, biz: BusinessIdentity, assetsBaseUrl = '') {
  return createPrintPort().savePdf({ document: printableQuotation(m, biz, assetsBaseUrl) });
}
